import React from 'react';
import { CheckCircle, XCircle, X, Ban, FileText } from 'lucide-react';

const DOC_LABELS = {
  selfie_with_license: 'Selfie mit Fuhrerschein',
  vehicle_registration: 'Fahrzeugzulassung',
  vehicle_photo: 'Fahrzeugfoto',
  insurance: 'Versicherungsnachweis',
  transport_license: 'Transportlizenz',
};

const DRIVER_STATUS = {
  pending: { label: 'Ausstehend', cls: 'bg-yellow-100 text-yellow-700' },
  approved: { label: 'Aktiv', cls: 'bg-emerald-100 text-emerald-700' },
  rejected: { label: 'Abgelehnt', cls: 'bg-red-100 text-red-700' },
  blocked: { label: 'Gesperrt', cls: 'bg-red-100 text-red-700' },
};

export function DocumentViewerModal({ data, onClose, onAction }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl max-w-3xl w-full max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-testid="doc-viewer-modal">
        <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between sticky top-0 bg-white z-10">
          <div>
            <h2 className="font-bold text-slate-800">Dokumente - {data.driver_name}</h2>
            <p className="text-sm text-slate-500">{data.driver_email} | {data.region} | Status: {DRIVER_STATUS[data.status]?.label || data.status}</p>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-lg"><X size={20} className="text-slate-400" /></button>
        </div>
        <div className="p-6">
          <div className="bg-slate-50 rounded-xl p-4 mb-6">
            <p className="text-xs text-slate-400 uppercase font-semibold mb-2">Fahrzeug</p>
            <p className="text-sm text-slate-800">{data.vehicle?.make} {data.vehicle?.model} ({data.vehicle?.year}) - {data.vehicle?.color}</p>
            <p className="text-sm text-slate-500">Kennzeichen: {data.vehicle?.plate_number} | Typ: {data.vehicle?.vehicle_type}</p>
          </div>
          <div className="grid gap-4">
            {Object.entries(DOC_LABELS).map(([key, label]) => {
              const doc = data.documents?.[key];
              return (
                <div key={key} className={`border rounded-xl overflow-hidden ${doc ? 'border-emerald-200' : 'border-slate-200'}`}>
                  <div className="flex items-center justify-between px-4 py-3 bg-slate-50">
                    <div className="flex items-center gap-2">
                      {doc ? <CheckCircle size={16} className="text-emerald-600" /> : <XCircle size={16} className="text-slate-300" />}
                      <span className="text-sm font-medium text-slate-700">{label}</span>
                    </div>
                    <span className={`text-xs font-medium ${doc ? 'text-emerald-600' : 'text-slate-400'}`}>
                      {doc ? 'Hochgeladen' : 'Fehlt'}
                    </span>
                  </div>
                  {doc && doc.startsWith('data:image') && (
                    <div className="p-4 bg-white">
                      <img src={doc} alt={label} className="max-h-64 w-full object-contain rounded-lg border border-slate-100" data-testid={`doc-img-${key}`} />
                    </div>
                  )}
                  {doc && !doc.startsWith('data:image') && (
                    <div className="p-4 bg-white">
                      <div className="flex items-center gap-2 text-sm text-slate-600"><FileText size={16} /> PDF-Dokument vorhanden</div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          <div className="flex gap-3 mt-6 pt-4 border-t border-slate-100">
            {data.status === 'pending' && (
              <>
                <button onClick={() => onAction('approve', data.driver_id)} className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-emerald-500 text-white rounded-xl font-medium hover:bg-emerald-600" data-testid="approve-from-docs">
                  <CheckCircle size={18} /> Genehmigen
                </button>
                <button onClick={() => onAction('reject', data.driver_id)} className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-red-500 text-white rounded-xl font-medium hover:bg-red-600" data-testid="reject-from-docs">
                  <XCircle size={18} /> Ablehnen
                </button>
              </>
            )}
            {data.status === 'approved' && (
              <button onClick={() => onAction('block', data.driver_id)} className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-red-500 text-white rounded-xl font-medium hover:bg-red-600">
                <Ban size={18} /> Sperren
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
